import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import AuthLayout from "../components/AuthLayout";
import authService from "../services/authService";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailValid = email === "" || emailRegex.test(email);
  const isValid = emailRegex.test(email) && password.trim() !== "";

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!isValid) return;
    setSubmitting(true);
    try {
      await authService.login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(err?.message || "Falha ao autenticar. Tente novamente.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Entrar em uma conta" widthClass="w-80">
      <form onSubmit={handleLogin} noValidate>
        <Input
          label="E-mail"
          type="email"
          placeholder="joaosilva@exemplo.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {!emailValid && (
          <p className="text-xs text-red-600 -mt-3 mb-3">Digite um e-mail válido.</p>
        )}

        <Input
          label="Senha"
          type="password"
          placeholder="Digite sua senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div className="flex items-center justify-between mb-6">
          <Checkbox label="Manter-me conectado." />
        </div>

        {error && (
          <p className="text-xs text-red-600 mb-3">{error}</p>
        )}

        <button
          type="submit"
          disabled={!isValid || submitting}
          className={`w-full h-10 rounded-lg transition font-medium ${
            isValid && !submitting
              ? "bg-purple-600 text-white hover:bg-purple-700"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          {submitting ? 'Entrando…' : 'Entrar'}
        </button>

        <p className="text-sm text-center mt-4 text-gray-600">
          Não tem uma conta?{" "}
          <Link to="/register" className="text-purple-600 font-medium">
            Clique aqui
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
}
